<template>
  <div>
    <div id="headers" class="fixed-top" @mouseleave="leaveheader">
      <!-- <div class="tipcon bg-colf9">
      <div class="tip flex jc-betweet ai-center">
        <div class="color-col54 fs-16 point">欢迎光临中商出版社</div>
        <div class="flex ai-center point">
          <img class="callicon" src="../../assets/image/call.png" alt="" />
          <span class="color-col54 fs-16 ml-10">联系我们</span>
        </div>
      </div>
    </div> -->
      <img class="bg" src="../../assets/image/bglogo.jpg" alt="" />
      <div class="headcon flex jc-betweet ai-center">
        <img src="../../assets/image/logo.png" alt="" />
        <div class="rightcon">
          <div class="searchcon flex">
            <input
              type="text"
              class="pl-20 fs-16 color-white"
              :value="keywords"
              placeholder="请输入图书名称"
              @keyup.enter="search()"
              @input="watchinput"
            />
            <div
              class="
                sercon
                bg-primary
                flex
                jc-center
                ai-center
                fs-20
                color-white
                point
              "
              @click="search()"
            >
              搜索
            </div>
          </div>
          <!-- <div class="mt-10 color-col95 fs-16 pl-20">
          搜索热词：<span>网络文学</span><span class="ml-20">电子书</span
          ><span class="ml-20">网络文学</span>
          <span class="ml-20">电子书</span>
        </div> -->
        </div>
      </div>
      <div class="navcon bg-primary">
        <div class="nav flex">
          <li
            class="text-center color-white fs-18 point transition"
            v-for="(item, index) in navlist"
            :class="[
              isActive == index && navid == index
                ? 'active'
                : navid == index
                ? 'active'
                : isActive == index
                ? 'active'
                : '',
            ]"
            :key="index"
            @mouseenter="chosenav(index)"
            @mouseleave="leavenav(index)"
            @click="changenav(index)"
          >
            {{ item.name }}
          </li>
          <div
            class="popcon"
            :style="{ height: isshowperiodical ? '1.18rem' : '' }"
          >
            <ul>
              <li
                class="text-center fs-16 point"
                :class="changeid == index ? 'active' : ''"
                v-for="(item, index) in periodicallist"
                :key="index"
                @mouseenter="permouse(index, 1)"
                @mouseleave="permouse(index, 2)"
                @click="perclick"
              >
                <a
                  v-if="item.link"
                  class="color-white"
                  :href="item.link"
                  target="_blank"
                  >{{ item.title }}</a
                >
                <span v-else class="color-white">{{ item.title }}</span>
              </li>
            </ul>
          </div>
          <div
            class="popcon1"
            :style="{ height: isshowabout ? '1.18rem' : '' }"
          >
            <ul>
              <li
                class="text-center fs-16 point"
                :class="changeaboutid == index ? 'active' : ''"
                v-for="(item, index) in aboutlist"
                :key="index"
                @mouseenter="aboutmouse(index, 1)"
                @mouseleave="aboutmouse(index, 2)"
                @click="aboutclick(item.url)"
              >
                <span class="color-white">{{ item.tit }}</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <div style="height: 185px"></div>
  </div>
</template>
<script>
export default {
  name: "headers",
  props: {},
  data() {
    return {
      navid: 0, //选中的导航id
      keywords: "经济贸易", //关键词
      isshowperiodical: false, //是否显示期刊列表
      isActive: 0, //滑过的导航id
      changeid: -1, //期刊的选中id
      isshowabout: false, //是否显示关于我们列表
      changeaboutid: -1, //关于我们选中id
      periodicallist: [], //期刊列表
      aboutlist: [
        //关于我们
        {
          tit: "社长致辞",
          url: "/about?type=0",
        },
        {
          tit: "企业简介",
          url: "/about?type=1",
        },
        {
          tit: "组织机构",
          url: "/about?type=2",
        },

        {
          tit: "企业荣誉",
          url: "/about?type=3",
        },
        {
          tit: "人才招聘",
          url: "/about?type=4",
        },
      ],
      navlist: [
        {
          name: "首页",
          url: "/index",
        },
        {
          name: "领导关怀",
          url: "/leadershipCare",
        },
        {
          name: "关于我们",
          url: "/about",
        },
        {
          name: "新闻",
          url: "/newslist",
        },
        {
          name: "图书",
          url: "/books",
        },
        {
          name: "期刊",
          url: "",
        },
        {
          name: "中商智库",
          url: "/thinkTank",
        },
        // {
        //   name: "合作交流",
        //   url: "/cooperation",
        // },
        {
          name: "商务阅读平台",
          url: "/businessReading",
        },
      ],
    };
  },
  watch: {
    $route(to, from) {
      if (to.path != "/booksearch") {
        localStorage.setItem("keywords", "");
        this.keywords = "经济贸易";
      }
    },
  },
  mounted() {
    this.boutiquebook();
    this.keywords = localStorage.getItem("keywords");
    this.navid = window.sessionStorage.getItem("navid");
    this.isActive = window.sessionStorage.getItem("navid");
  },
  methods: {
    //获取精品期刊列表
    async boutiquebook() {
      var res = await this.$API.API_Ajax("期刊列表", {
        columnId: 15,
      });
      if (res.code == 200) {
        this.periodicallist = res.data;
        console.log(this.periodicallist);
      }
    },
    //离开顶部的时间
    leaveheader() {
      this.isshowperiodical = false;
      this.isshowabout = false;
    },
    //鼠标滑过期刊
    permouse(index, type) {
      if (type == 1) {
        this.changeid = index;
      } else {
        this.changeid = -1;
      }
    },
    //鼠标点击
    perclick() {
      this.changeid = -1;
    },
    //关于我们滑过
    aboutmouse(index, type) {
      if (type == 1) {
        this.changeaboutid = index;
      } else {
        this.changeaboutid = -1;
      }
    },
    //关于我们点击
    aboutclick(url) {
      this.changeaboutid = -1;
      this.$router.push({ path: url });
      setTimeout(() => {
        window.location.reload();
      }, 500);
    },
    //导航的鼠标滑过功能
    chosenav(index) {
      this.isActive = index;
      if (index == 5) {
        this.isshowperiodical = true;
      } else {
        this.isshowperiodical = false;
      }
      if (index == 2) {
        this.isshowabout = true;
      } else {
        this.isshowabout = false;
      }
    },
    //导航的鼠标滑过功能
    leavenav(index) {
      this.isActive = -1;
    },
    //监听输入
    watchinput(e) {
      this.keywords = e.currentTarget.value;
    },
    //搜索
    search() {
      localStorage.setItem("keywords", this.keywords);
      this.$router.push({ path: "/booksearch?" });
      if (this.$route.path == "/booksearch") {
        this.$router.go(0);
      }
    },
    //导航切换
    changenav(index) {
      this.navid = index;
      window.sessionStorage.setItem("navid", this.navid);
      var url = this.navlist[index].url;
      if (index == 5) {
        this.isshowperiodical = !this.isshowperiodical;
        this.isshowabout = false;
      } else if (index == 2) {
        this.isshowabout = !this.isshowabout;
        this.isshowperiodical = false;
      } else if (index == 6) {
        window.open("http://www.cctpress.com/dist/index.html", "_blank");
      } else {
        this.isshowperiodical = false;
        if (this.$route.path == url) {
          this.$router.replace({ path: url });
          this.$router.go(0);
        } else {
          this.$router.replace({ path: url });
        }
      }
    },
  },
};
</script>
<style lang="scss" scoped>
#headers {
  width: 100%;
  z-index: 99999999;
  background-color: #196bc1;
  position: fixed;
  top: 0;
  left: 0;
  .tipcon {
    width: 100%;
    height: 46px;
    border-bottom: 1px solid #e8e8e8;
    .tip {
      width: 67%;
      height: 100%;
      margin: auto;
      .callicon {
        width: 18px;
        height: 18px;
      }
    }
  }
  .bg {
    width: 100%;
    height: 120px;
  }
  .headcon {
    width: 65%;
    height: 120px;
    margin: auto;
    position: absolute;
    top: 0;
    left: 360px;
    z-index: 999;
    img {
      width: 323px;
      height: 65px;
    }
    .rightcon {
      .searchcon {
        width: 483px;
        height: 41px;
        input {
          width: 80%;
          height: 100%;
          background-color: transparent;
          border-top: 2px solid rgba(255, 255, 255, 0.3);
          border-left: 2px solid rgba(255, 255, 255, 0.3);
          border-bottom: 2px solid rgba(255, 255, 255, 0.3);
        }
        .sercon {
          width: 20%;
          height: 41px;
          border: 2px solid #3b8ce0;
        }
      }
    }
  }
  .navcon {
    width: 100%;
    height: 67px;
    .nav {
      width: 65%;
      height: 100%;
      margin: auto;
      position: relative;
      li {
        width: 13%;
        height: 67px;
        line-height: 67px;
      }
      .active {
        background: #196bc1;
      }
      .popcon {
        width: 160px;
        height: 0px;
        transition-duration: 1s;
        transition-property: all;
        transition-timing-function: ease;
        transition-delay: 0s;
        position: absolute;
        top: 66px;
        left: 62.3%;
        border-bottom-left-radius: 10px;
        border-bottom-right-radius: 10px;
        background-color: rgba(59, 140, 224, 0.5);
        overflow: hidden;
        ul li {
          width: 100%;
          height: 45px;
          line-height: 45px;
        }
        .active {
          background: #196bc1;
        }
        .active:last-child {
          background: #196bc1;
          border-bottom-left-radius: 10px;
          border-bottom-right-radius: 10px;
        }
      }
      .popcon1 {
        width: 160px;
        height: 0px;
        transition-duration: 1s;
        transition-property: all;
        transition-timing-function: ease;
        transition-delay: 0s;
        position: absolute;
        top: 66px;
        left: 24.8%;
        border-bottom-left-radius: 10px;
        border-bottom-right-radius: 10px;
        overflow: hidden;
        background-color: rgba(59, 140, 224, 0.5);
        ul li {
          width: 100%;
          height: 45px;
          line-height: 45px;
        }
        .active {
          background: #196bc1;
        }
        .active:last-child {
          background: #196bc1;
          border-bottom-left-radius: 10px;
          border-bottom-right-radius: 10px;
        }
      }
    }
  }
}
</style>
